import { Component } from '@angular/core';
import { first } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { User } from '@app/_models';
import { AuthenticationService } from '@app/_services';

@Component({ 
    styleUrls: ['./home.component.css'],
    templateUrl: 'home.component.html' 
})
export class HomeComponent {
    loading = false;
    currentUser: User;
    userLoggedIn: boolean=false;

    constructor(private authenticationService: AuthenticationService) {
        this.authenticationService.currentUser.subscribe(x =>{
            this.currentUser = x
            if(this.currentUser){
                this.userLoggedIn = true;
            }
        });

     }

    ngOnInit() {
//        this.loading = true;
    }
}